import React from 'react';

import IconButton from '@atlaskit/button/icon/button';
import { SplitButton } from '@atlaskit/button/split-button/split-button';
// eslint-disable-next-line @atlaskit/design-system/no-emotion-primitives -- to be migrated to @atlaskit/primitives/compiled – go/akcss
import Box from '@atlaskit/primitives/box';
import { xcss } from '@atlaskit/primitives/xcss';
import { token } from '@atlaskit/tokens';

import { useSSRPlaceholderReplaceIdProp } from '@confluence/loadable';

import { ShareAndRestrictButtonPlaceholder } from './ShareAndRestrictButtonPlaceholder.tsx';

const iconSkeletonStyle = xcss({
	width: '16px',
	height: '16px',
	borderRadius: 'radius.xsmall',
	background: token('color.background.accent.gray.subtlest.hovered'),
});

const SkeletonGlyph = () => <Box testId="icon-skeleton" xcss={iconSkeletonStyle} />;

export const ShareRestrictAndCopyButtonPlaceholder = (): React.JSX.Element => {
	const ssrPlaceholderIdProp = useSSRPlaceholderReplaceIdProp();
	return (
		<div {...ssrPlaceholderIdProp}>
			<SplitButton>
				<ShareAndRestrictButtonPlaceholder />
				<IconButton
					testId="copy-link-button-placeholder"
					icon={SkeletonGlyph}
					label=""
					isDisabled
				/>
			</SplitButton>
		</div>
	);
};
